export const AutomationData = [
  {
    id: '1',
    title: 'Appointment reminder',
    trigger: 'Any message',
    started: '41',
    inProgress: '5',
    completed: '10',
    status: true,
    data: {
      nodes: [
        {
          id: '1',
          position: {x: 100, y: 100},
          type: 'trigger',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '2',
          type: 'timeDelay',
          position: {x: 100, y: 250},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '3',
          position: {x: 100, y: 400},
          data: {isDisableBottomHandler: true},
          type: 'sendMessage',
          draggable: false,
          connectable: false,
          deletable: false,
        },
      ],
      edges: [
        {id: 'e1-2', source: '1', target: '2', deletable: false, selected: false},
        {id: 'e1-3', source: '2', target: '3', deletable: false, selected: false},
      ],
    },
  },
  {
    id: '2',
    title: 'Help',
    trigger: 'Starts with',
    started: '25',
    inProgress: '14',
    completed: '5',
    status: false,
    data: {
      nodes: [
        {
          id: '1',
          position: {x: 100, y: 100},
          type: 'trigger',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '2',
          type: 'sendMessage',
          position: {x: 100, y: 250},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '3',
          position: {x: 100, y: 400},
          type: 'timeDelay',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '4',
          type: 'sendMessage',
          position: {x: 100, y: 550},
          data: {isDisableBottomHandler: true},
          draggable: false,
          connectable: false,
          deletable: false,
        },
      ],
      edges: [
        {id: 'e1-2', source: '1', target: '2', deletable: false, selected: false},
        {id: 'e1-3', source: '2', target: '3', deletable: false, selected: false},
        {id: 'e1-4', source: '3', target: '4', deletable: false, selected: false},
      ],
    },
  },
  {
    id: '3',
    title: 'Coupon',
    trigger: 'Any message',
    started: '41',
    inProgress: '5',
    completed: '10',
    status: false,
    data: {
      nodes: [
        {
          id: '1',
          position: {x: 100, y: 100},
          type: 'trigger',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '2',
          type: 'sendMessage',
          position: {x: 100, y: 250},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '3',
          position: {x: 100, y: 400},
          type: 'timeDelay',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '4',
          type: 'conditionalSplit',
          position: {x: 100, y: 550},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '5',
          position: {x: 100, y: 700},
          type: 'sendMessage',
          data: {isDisableBottomHandler: true},
          draggable: false,
          connectable: false,
          deletable: false,
        },
      ],
      edges: [
        {id: 'e1-2', source: '1', target: '2', deletable: false, selected: false},
        {id: 'e1-3', source: '2', target: '3', deletable: false, selected: false},
        {id: 'e1-4', source: '3', target: '4', deletable: false, selected: false},
        {id: 'e1-5', source: '4', target: '5', deletable: false, selected: false},
      ],
    },
  },
  {
    id: '4',
    title: 'Fitness',
    trigger: 'Starts with',
    started: '25',
    inProgress: '14',
    completed: '5',
    status: true,
    data: {
      nodes: [
        {
          id: '1',
          position: {x: 100, y: 100},
          type: 'trigger',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '2',
          type: 'sendMessage',
          position: {x: 100, y: 250},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '3',
          position: {x: 100, y: 400},
          type: 'timeDelay',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '4',
          type: 'sendMessage',
          position: {x: 100, y: 550},
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '5',
          position: {x: 100, y: 700},
          type: 'conditionalSplit',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '6',
          position: {x: 100, y: 850},
          type: 'timeDelay',
          draggable: false,
          connectable: false,
          deletable: false,
        },
        {
          id: '7',
          position: {x: 100, y: 1000},
          type: 'sendMessage',
          data: {isDisableBottomHandler: true},
          draggable: false,
          connectable: false,
          deletable: false,
        },
      ],
      edges: [
        {id: 'e1-2', source: '1', target: '2', deletable: false, selected: false},
        {id: 'e1-3', source: '2', target: '3', deletable: false, selected: false},
        {id: 'e1-4', source: '3', target: '4', deletable: false, selected: false},
        {id: 'e1-5', source: '4', target: '5', deletable: false, selected: false},
        {id: 'e1-6', source: '5', target: '6', deletable: false, selected: false},
        {id: 'e1-7', source: '6', target: '7', deletable: false, selected: false},
      ],
    },
  },
]
